// src/pages/EditarDados.js
import React, { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../api";
import Menu from "../components/Menu";
import "./EditarDados.css";

export default function EditarDados() {
  const [displayName, setDisplayName] = useState("");
  const [originDisplayName, setOriginDisplayName] = useState("");
  const [senha, setSenha] = useState("");
  const [me, setMe] = useState(null);

  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [changingPass, setChangingPass] = useState(false);

  const [error, setError] = useState("");
  const [successMsg, setSuccessMsg] = useState("");

  const navigate = useNavigate();

  const isDirty = useMemo(() => {
    return displayName !== originDisplayName || senha.length > 0;
  }, [displayName, originDisplayName, senha]);

  useEffect(() => {
    const fetchMe = async () => {
      setLoading(true);
      setError("");
      setSuccessMsg("");
      try {
        const token = localStorage.getItem("authToken");
        const headers = token ? { Authorization: `Bearer ${token}` } : {};
        const res = await api.get("/api/players/me", { headers });

        const payload = res.data || {};
        setMe(payload);

        const dn = payload.display_name || "";
        setDisplayName(dn);
        setOriginDisplayName(dn);
      } catch (err) {
        setError(err?.response?.data?.error || "Erro ao carregar seus dados.");
      } finally {
        setLoading(false);
      }
    };
    fetchMe();
  }, []);

  const handleSave = async () => {
    setSaving(true);
    setError("");
    setSuccessMsg("");
    try {
      if (!displayName.trim()) throw new Error("Informe seu nome.");
      if (senha && senha.length < 6) throw new Error("A nova senha deve ter pelo menos 6 caracteres.");

      const token = localStorage.getItem("authToken");
      const headers = token ? { Authorization: `Bearer ${token}` } : {};

      await api.put("/api/players/me", { display_name: displayName }, { headers });

      if (senha) {
        setChangingPass(true);
        await api.put("/api/players/me/password", { senha }, { headers });
        setChangingPass(false);
        setSenha("");
      }

      setOriginDisplayName(displayName);
      setSuccessMsg("Dados atualizados com sucesso!");
    } catch (err) {
      const msg = err?.response?.data?.error || err.message || "Erro ao salvar seus dados.";
      setError(msg);
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="ed-shell">
      <header className="ed-navbar">
        {/* O Menu vira uma navbar full-width, sem “grudar” no canto */}
        <Menu />
      </header>

      <main className="ed-content">
        <header className="ed-header">
          <h1>Meu Perfil</h1>
          <p>Atualize seu nome e, se quiser, defina uma nova senha.</p>
        </header>

        {loading ? (
          <div className="ed-card ed-loading">
            <div className="ed-spinner" />
            <span>Carregando...</span>
          </div>
        ) : (
          <>
            {!!error && <div className="ed-alert ed-alert-error">{error}</div>}
            {!!successMsg && <div className="ed-alert ed-alert-success">{successMsg}</div>}

            <section className="ed-grid single">
              <div className="ed-card">
                <div className="ed-card-title">Dados do jogador</div>

                <div className="ed-field">
                  <label htmlFor="display_name">Nome</label>
                  <input
                    id="display_name"
                    type="text"
                    value={displayName}
                    onChange={(e) => {
                      setError("");
                      setSuccessMsg("");
                      setDisplayName(e.target.value);
                    }}
                    placeholder="Seu nome completo"
                    autoComplete="name"
                  />
                </div>

                <div className="ed-field">
                  <label>WhatsApp ID (somente leitura)</label>
                  <input type="text" value={me?.wa_jid || me?.id || "—"} readOnly />
                  <small className="ed-help">
                    Usado para vincular sua conta aos grupos. Não alterável por aqui.
                  </small>
                </div>
              </div>

              <div className="ed-card">
                <div className="ed-card-title">Trocar senha</div>

                <div className="ed-field">
                  <label htmlFor="senha">Nova senha (opcional)</label>
                  <input
                    id="senha"
                    type="password"
                    value={senha}
                    onChange={(e) => {
                      setError("");
                      setSuccessMsg("");
                      setSenha(e.target.value);
                    }}
                    placeholder="••••••••"
                    autoComplete="new-password"
                  />
                  <small className="ed-help">Mínimo de 6 caracteres.</small>
                </div>
              </div>
            </section>

            <div className="ed-actions">
              <button
                type="button"
                className="ed-btn ed-btn-secondary"
                onClick={() => navigate("/dashboard")}
              >
                Voltar
              </button>

              <button
                type="button"
                className="ed-btn ed-btn-primary"
                onClick={handleSave}
                disabled={!isDirty || saving || changingPass}
              >
                {saving || changingPass ? "Salvando..." : "Salvar alterações"}
              </button>
            </div>
          </>
        )}
      </main>
    </div>
  );
}
